export default "__VITE_ASSET__BKUy_p7J__"